module.exports = __webpack_public_path__ + "static/media/refresh.a78134e6.svg";